import { render } from "./AddonCategories.vue?vue&type=template&id=827d7efa&scoped=true"
import script from "./AddonCategories.vue?vue&type=script&lang=js"
export * from "./AddonCategories.vue?vue&type=script&lang=js"

import "./AddonCategories.vue?vue&type=style&index=0&id=827d7efa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827d7efa"]])

export default __exports__